const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const instanceConnect = async (instanceId: any): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/instance/connect/${instanceId}`, {
      method: 'GET',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao conectar instância:', error);
  }
}

export default instanceConnect;